/**
 * Camera settings — player-tunable camera move (pan) speed, persisted to
 * localStorage so it survives reloads.
 *
 * The pan loop in main.ts multiplies its baseline pan speed by
 * getCameraSpeedMultiplier(). The settings panel renders a slider that writes
 * setCameraSpeedMultiplier(). 1.0 = the shipped default; the slider spans
 * MIN..MAX so players can slow scouting down or speed it back up to the old
 * (pre-halving) feel at 2.0.
 */
const STORAGE_KEY = "tribez.cameraSpeed";

export const CAMERA_SPEED_MIN = 0.25;
export const CAMERA_SPEED_MAX = 2.0;
export const CAMERA_SPEED_DEFAULT = 1.0;

let multiplier = load();

function load(): number {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === null) return CAMERA_SPEED_DEFAULT;
    const n = Number(raw);
    if (!Number.isFinite(n)) return CAMERA_SPEED_DEFAULT;
    return clamp(n);
  } catch {
    return CAMERA_SPEED_DEFAULT;
  }
}

function clamp(n: number): number {
  return Math.min(CAMERA_SPEED_MAX, Math.max(CAMERA_SPEED_MIN, n));
}

export function getCameraSpeedMultiplier(): number {
  return multiplier;
}

export function setCameraSpeedMultiplier(n: number): void {
  multiplier = clamp(n);
  try {
    localStorage.setItem(STORAGE_KEY, String(multiplier));
  } catch {
    /* private-mode / quota — keep the in-memory value, just don't persist. */
  }
}
